import React from 'react'

export const TagGroupContext = React.createContext(null)
